export default "__VITE_ASSET__60d3ca26__"